import { render, staticRenderFns } from "./OrgForm.vue?vue&type=template&id=b2d200cc&scoped=true"
import script from "./OrgForm.vue?vue&type=script&lang=js"
export * from "./OrgForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d200cc",
  null
  
)

export default component.exports